import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

const historyData = [
  {
    year: '1996',
    items: [{ date: '1996.08', content: '삼원판넬탱크 창업' }],
  },
  {
    year: '1999',
    items: [
      {
        date: '1999.06',
        content: '㈜삼원판넬탱크로 법인전환 (자본금 50,000,000원)',
      },
    ],
  },
  {
    year: '2000',
    items: [
      { date: '2000.07', content: 'ISO 9002 인증 획득' },
      {
        date: '2000.08',
        content: '공장이전 (전남 화순군 능주면 잠정리 7-13번지)',
      },
    ],
  },
  {
    year: '2003',
    items: [
      {
        date: '2003.07',
        content:
          '본점이전 및 상호변경 (광주광역시 북구 월출동 970-25 ㈜삼원테크)',
      },
    ],
  },
  {
    year: '2007',
    items: [
      {
        date: '2007.03',
        content:
          '공장이전 및 생산설비 투입 160,000,000원 (전남 화순군 동면 운농리 1036번지 동면 농공단지 내)',
      },
      { date: '2007.07', content: '중소기업청 직접생산업체 확인 (직접생산확인서)' },
      { date: '2007.07', content: 'STS패널 및 원통형 탱크에 대한 특허출원' },
      { date: '2007.10', content: '본점이전 (전남 화순군 동면 운농리 1042-7)' },
      { date: '2007.12', content: 'STS 패널 및 원통형 탱크에 대한 특허등록' },
    ],
  },
  {
    year: '2008',
    items: [
      {
        date: '2008.08',
        content:
          '품질경영시스템(ISO9001:2000) 및 환경경영시스템(ISO14001:2004) 인증취득',
      },
      { date: '2008.12', content: 'K마크(성능) 인증취득 (PB12008-100)' },
    ],
  },
  {
    year: '2009',
    items: [
      { date: '2009.04', content: 'STS물탱크에 대한 라이닝 특허등록 (제10-0896531호)' },
      { date: '2009.06', content: '전라남도(기술)유망중소기업 지정' },
    ],
  },
  {
    year: '2010',
    items: [
      { date: '2010.03', content: 'KS Q/ISO 9001:2008 인증취득 (QAIC/KR/2847-B)' },
      { date: '2010.03', content: '경영혁신형 중소기업(MAIN-BIZ) 선정 (중소기업청)' },
      { date: '2010.05', content: '기술혁신형 중소기업(INNO-BIZ) 선정 (중소기업청)' },
      { date: '2010.11', content: '폴리에틸렌(PE)관 직접생산 인증 (중소기업중앙회)' },
      { date: '2010.12', content: '폴리에틸렌 이음관에 대한 특허등록 (제10-1006563호)' },
    ],
  },
  {
    year: '2011',
    items: [
      { date: '2011.08', content: '폴리에틸렌 하수도관의 연결구 우수단체표준제품인증' },
      { date: '2011.10', content: '자본금 증자 (500,000,000원)' },
    ],
  },
  {
    year: '2012',
    items: [
      { date: '2012.02', content: '스테인리스 물탱크 우수단체표준제품인증' },
      { date: '2012.05', content: '일반용폴리에틸렌이음관, 스테인리스 물탱크 Q마크 인증' },
    ],
  },
  {
    year: '2013',
    items: [
      { date: '2013.05', content: 'KC인증 (위생안전기준)' },
      { date: '2013.10', content: 'KS인증 (스테인리스물탱크)' },
    ],
  },
  {
    year: '2014',
    items: [
      { date: '2014.07', content: '라이닝 판넬을 가지는 저장탱크 (특허 제1422783호)' },
      { date: '2014.08', content: '코어보강부를 가지는 저장탱크 (특허 제11-1433352호)' },
      { date: '2014.10', content: '물탱크 조립체 (특허 제10-14618718호)' },
    ],
  },
  {
    year: '2015',
    items: [
      {
        date: '2015.03',
        content: '단체표준 인증서 (스테인리스 패널형 물탱크, 스테인리스 원통형 물탱크)',
      },
      { date: '2015.03', content: '직접생산확인 인증서 (스테인리스 물탱크)' },
    ],
  },
  {
    year: '2018',
    items: [{ date: '2018.02', content: '직접생산확인 인증서 (폴리에틸렌 PE관)' }],
  },
];

const HistoryPage = () => {
  useEffect(() => {
    document.title = '삼원테크 | 회사 연혁 - 1996년 창업부터 현재까지';
    document.querySelector('meta[name="description"]')?.setAttribute(
      'content',
      '삼원테크 회사 연혁. 1996년 창업 이후 ISO9001·ISO14001·KS 인증 획득, 10건 이상 특허 등록 등 30년간의 성장 발자취를 확인하세요.'
    );
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about/history#webpage`,
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about/history`,
      "name": "삼원테크 회사 연혁",
      "description": "1996년 창업 이후 ISO9001·ISO14001·KS 인증 획득, 10건 이상 특허 등록 등 30년간의 성장 발자취.",
      "inLanguage": "ko-KR",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "홈", "item": import.meta.env.VITE_SITE_URL || 'https://example.com' },
          { "@type": "ListItem", "position": 2, "name": "회사소개", "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about` },
          { "@type": "ListItem", "position": 3, "name": "회사 연혁", "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about/history` }
        ]
      }
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-history';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById('schema-history')?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <div className="relative h-[50vh] w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/7a156b1aea88f8b0df69e0a94491731a.jpg"
            alt="연혁"
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
        </div>
        <div className="relative h-full flex flex-col items-center justify-center text-white px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <span className="text-sm uppercase tracking-[3px] text-teal-300 font-semibold">
              History
            </span>
            <h1 className="text-5xl md:text-6xl font-bold mt-4 mb-5">회사 연혁</h1>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed">
              1996년 창업 이후 끊임없는 도전과 혁신으로
              <br />
              대한민국 물탱크 산업을 선도해온 삼원테크의 발자취
            </p>
          </motion.div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="px-4 py-24 bg-white">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-20">
            <span className="text-sm uppercase tracking-[2px] text-teal-600 font-semibold">
              Timeline
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-3">주요 연혁</h2>
          </div>

          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-[120px] top-0 bottom-0 w-px bg-gradient-to-b from-teal-200 via-teal-400 to-teal-200"></div>

            <div className="space-y-12">
              {historyData.map((group, groupIdx) => (
                <motion.div
                  key={group.year}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5, delay: groupIdx * 0.04 }}
                  className="relative flex gap-0"
                >
                  {/* Year Label */}
                  <div className="w-[120px] flex-shrink-0 flex items-start justify-end pr-8 pt-1">
                    <span className="text-2xl font-bold text-teal-600 leading-none">{group.year}</span>
                  </div>

                  {/* Dot */}
                  <div className="absolute left-[120px] top-2 transform -translate-x-1/2">
                    <div className="w-4 h-4 bg-teal-500 rounded-full border-4 border-white shadow-md ring-2 ring-teal-200"></div>
                  </div>

                  {/* Items */}
                  <div className="flex-1 pl-10 space-y-3">
                    {group.items.map((item, itemIdx) => (
                      <div
                        key={itemIdx}
                        className="bg-gray-50 rounded-xl px-6 py-4 border border-gray-100 hover:border-teal-200 hover:bg-teal-50/40 transition-all duration-300"
                      >
                        <div className="flex items-start gap-4">
                          <span className="text-sm font-semibold text-teal-500 whitespace-nowrap mt-0.5 min-w-[60px]">
                            {item.date.slice(5)}
                          </span>
                          <span className="text-gray-700 text-base leading-relaxed">{item.content}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Stats Summary */}
      <div className="px-4 py-20 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-white mb-4">삼원테크의 성과</h2>
            <p className="text-lg text-white/85">숫자로 보는 삼원테크의 성장</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: '20+', label: '년 업력', icon: 'ri-time-line' },
              { number: '10+', label: '특허 등록', icon: 'ri-award-line' },
              { number: '15+', label: '인증 획득', icon: 'ri-medal-line' },
              { number: '100%', label: '직접 생산', icon: 'ri-building-line' },
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center text-white"
              >
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-white/10 rounded-2xl">
                  <i className={`${stat.icon} text-4xl`}></i>
                </div>
                <div className="text-5xl font-bold mb-2">{stat.number}</div>
                <div className="text-lg font-medium opacity-85">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HistoryPage;
